import Marquee from 'react-fast-marquee';
import s from './Topbar.module.scss';
import { usewpdataSelectors } from 'lib/wpdataState/selectors';
import { decode } from 'html-entities';
import { useEffect, useState } from 'react';
import { readCookie, writeCookie } from '../../../utils/helpers';

const COOKIE_KEY = 'time_left';
const COOLDOWN_MS = 24 * 60 * 60 * 1000;

const Topbar = () => {
  const { DiscountBar, MiddleBar, Layout } = usewpdataSelectors();
  const initialSeconds = Number(DiscountBar?.timer) * 60 || 9600;
  const [timeLeft, setTimeLeft] = useState(() => {
    const cookie = readCookie(COOKIE_KEY);
    const now = Date.now();
    if (cookie && cookie.endAt && cookie.cooldownExpires > now) {
      return Math.max(Math.floor((cookie.endAt - now) / 1000), 0);
    }
    return initialSeconds;
  });

  useEffect(() => {
    const now = Date.now();
    let cookie = readCookie(COOKIE_KEY);
    let endAt, cooldownExpires;
    if (cookie && cookie.endAt && cookie.cooldownExpires > now) {
      endAt = cookie.endAt;
      cooldownExpires = cookie.cooldownExpires;
    } else {
      endAt = now + timeLeft * 1000;
      cooldownExpires = now + COOLDOWN_MS;
      writeCookie(COOKIE_KEY, { endAt, cooldownExpires }, cooldownExpires);
    }

    if (timeLeft <= 0) return;

    const intervalId = setInterval(() => {
      setTimeLeft((prev) => {
        const next = Math.max(prev - 1, 0);
        return next;
      });
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  const hours = Math.floor(timeLeft / 3600)
    .toString()
    .padStart(2, '0');
  const minutes = Math.floor((timeLeft % 3600) / 60)
    .toString()
    .padStart(2, '0');
  const seconds = (timeLeft % 60).toString().padStart(2, '0');

  return (
    <div>
      {timeLeft > 0 && (
        <div className={s.topbar} style={{ background: DiscountBar.styles?.background }}>
          <div style={{ color: DiscountBar.styles?.textColor }}>{DiscountBar.text}</div>
          <div className={s.countdown}>
            <div className={s.card}>
              <div className={s.value}>{hours}</div>
              <div className={s.label}>HRS</div>
            </div>
            <p className={s.seperator}>:</p>
            <div className={s.card}>
              <div className={s.value}>{minutes}</div>
              <div className={s.label}>MIN</div>
            </div>
            <p className={s.seperator}>:</p>
            <div className={s.card}>
              <div className={s.value}>{seconds}</div>
              <div className={s.label}>SEC</div>
            </div>
          </div>
        </div>
      )}

      {MiddleBar.list && Layout?.middleBar.display && (
        <div className={s.scrollbar} style={{ background: MiddleBar.styles.background }}>
          <div className={s.wrapper}>
            <Marquee autoFill={true}>
              {MiddleBar?.list.map((text: { tr_text: string }, index: number) => (
                <div className={s.text} key={index} style={{ color: MiddleBar.styles.textColor }}>
                  {decode(text.tr_text)}
                </div>
              ))}
            </Marquee>
          </div>
        </div>
      )}
    </div>
  );
};

export default Topbar;
